<template>
  <v-container class="py-6">
    <v-card>
      <AccountMetaInfo :account="account" @save="updateAccount" />
      <v-card-title>
        <h2>Clients</h2>
        <v-spacer></v-spacer>
        <v-btn
          small
          icon
          class="float-sm-right mt-2 mx-2"
          @click="creatingClient = true"
        >
          <v-icon class="mr-1">mdi-plus-box-outline</v-icon>
        </v-btn>
      </v-card-title>
      <NewClient
        v-if="creatingClient"
        :accountId="account.id"
        @cancelClientCreate="creatingClient = false"
        @createReq="creatingClient = true"
      />
      <v-divider></v-divider>
      <v-card-text>
        <div
          v-if="loadingClients"
          class="mt-auto d-flex align-center justify-center mb-8"
        >
          <v-progress-circular class="px-8" indeterminate></v-progress-circular>
          <span>Fetching clients...</span>
        </div>
        <transition name="stf-fade">
          <v-container>
            <v-row v-if="!loadingClients" class="clients-list">
              <v-col
                v-for="client in clients"
                :key="client.id"
                cols="12"
                md="6"
              >
                <v-container class="client-card py-4 px-4">
                  <router-link
                    :to="`/pages/research/client/${client.id}`"
                    class="no-decoration"
                  >
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">{{
                          client.name
                        }}</v-list-item-title>
                        <v-list-item-subtitle>
                          Address: {{ client.address }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          Phone: {{ client.phone }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          Status: {{ client.status ? 'Active' : 'Inactive' }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          Created At: {{ formatDate(client.created_at) }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          Updated At: {{ formatDate(client.updated_at) }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </router-link>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </transition>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import AccountMetaInfo from '@/views/Components/AccountMetaInfo.vue'
  import NewClient from '@/views/Components/NewClient.vue'

  export default {
    name: 'UserDetails',
    data() {
      return {
        account: {},
        clients: [],
        loadingClients: true,
        creatingClient: false,
      }
    },
    components: {
      AccountMetaInfo,
      NewClient,
    },
    methods: {
      formatDate(date) {
        return new Date(date).toLocaleDateString()
      },
      getAccount() {
        const userId = this.$route.params.accountId
        this.apiGetAccount(userId)
          .then(response => {
            this.account = response
            this.clients = response.clients
            this.loadingClients = false
            console.log(this.account)
          })
          .catch(error => {
            console.log(error)
          })
      },
      updateAccount(details) {
        for (let key of [
          'created_at',
          'updated_at',
          'deleted_at',
          'id',
          'clients',
        ])
          delete details[key]
        this.apiModifyAccount(this.$route.params.accountId, details)
          .then(response => {
            console.log(response)
            this.account = response
          })
          .catch(error => {
            console.log(error)
          })
      },
      createClient(payload) {
        this.apiCreateClient(payload).then(response => {
          console.log(response)
        })
      },
    },
    mounted() {
      this.getAccount()
    },
  }
</script>

<style>
  .client-card {
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 1.5px 4px rgba(0, 0, 0, 0.06);
    border-radius: 8px;
  }
  .no-decoration {
    text-decoration: none;
    color: inherit;
  }
</style>
